import React from 'react';
import { Grid, Rectangle, Shimmer } from '@pitchero/react-ui';

const PhotoLoading = () => (
  <Rectangle fill="black" style={{ height: '100vh' }}>
    <Grid columns="1fr 10fr 1fr">
      <div style={{ alignSelf: 'center' }}>
        <Shimmer
          style={{
            borderRadius: 60,
            height: 36,
            width: 36,
            margin: '0 0 0 10%',
            opacity: '0.1',
          }}
        />
      </div>

      <div style={{ alignSelf: 'center' }}>
        <div>
          <Shimmer
            height={540}
            width={960}
            borderRadius="4px"
            style={{
              opacity: '0.1',
              margin: '0 auto',
              maxWidth: 'calc(100vw - 100px)',
            }}
          />
        </div>
      </div>

      <div style={{ alignSelf: 'center' }}>
        <Shimmer
          style={{
            borderRadius: 60,
            height: 36,
            width: 36,
            float: 'right',
            margin: '0 10% 0 0',
            opacity: '0.1',
          }}
        />
      </div>
    </Grid>
  </Rectangle>
);

export default PhotoLoading;
